import type { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import type { NavigateFunction } from "react-router-dom";

import CanvasForm from "src/pages/Settings/Canvas/Form";
import type { StateType } from "src/redux/reducers";
import { actions as canvasActions } from "src/redux/reducers/canvas";

const mapStateToProps = (state: StateType) => ({
	submitting: state.canvas.detail.submitting,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createCanvas: (name: string, width: number, height: number, navigate?: NavigateFunction) =>
		dispatch(canvasActions.requestCreateCanvas({ data: { name, width, height }, navigate })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CanvasForm);
